import { z } from "zod";

export const emailSchema = z
  .string({ message: "E-Mail-Adresse ist erforderlich" })
  .min(1, "E-Mail-Adresse ist erforderlich")
  .trim()
  .toLowerCase()
  .regex(
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    "Bitte eine gültige E-Mail-Adresse eingeben"
  );

// Optional email schema - validates email format if provided, but allows undefined/null
export const optionalEmailSchema = z
  .string()
  .optional()
  .refine(
    (email) => {
      if (!email || email.trim() === "") return true;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim().toLowerCase());
    },
    {
      message: "Bitte eine gültige E-Mail-Adresse eingeben",
    }
  )
  .transform((email) => {
    if (!email || email.trim() === "") return undefined;
    return email.trim().toLowerCase();
  });

// Email type for type inference
export type EmailSchemaT = z.infer<typeof emailSchema>;
export type OptionalEmailSchemaT = z.infer<typeof optionalEmailSchema>;
